export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Потрібно підтвердження"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацію необхідно підтвердити одноразовим ключем"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Авторизацію необхідно підтвердити чарівним словом"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Реєстрацію необхідно підтвердити кодом з SMS-повідомлення"])}
}